import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {fontSize, primaryGreenBtn, tabletWidth, wh} from '../../mixins';
import ProgressBar from '../../UI/ProgressBar';
import {useDispatch, useSelector} from 'react-redux';
import {selectEventsData, setPseudoPhone, setTrackingStatus} from './onboardingSlice';
import {sendAnalyticsEvents} from '../../analytics/common';
import {EVENTS} from '../../analytics/events';
import PhoneInputComp from '../../UI/PhoneInputComp';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 470px;
  
  @media screen and (max-width: ${tabletWidth}) {
    width: fit-content;
  }
`

const StyledTitle = styled.b`
  ${fontSize(24)};
  line-height: 40px;
  font-weight: 800;
  color: #323232;
  mix-blend-mode: normal;
`

const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 15px;
  
  @media screen and (max-width: ${tabletWidth}) {
    flex-direction: column;
    align-items: center;
    min-height: 120px;
  }
`

const StyledButton = styled.button`
  ${primaryGreenBtn};
  ${wh('25%', '42px')};
  
  @media screen and (max-width: ${tabletWidth}) {
    ${wh('80%', '42px')};
  }
`

const StyledText = styled.p`
  margin: 5px 0;
  ${fontSize(14)};
  line-height: 18px;
  color: #899497;
`

const StyledProgressWrap = styled.div`
  margin-top: 20px;
`

const LocatingPopup = ({country}) => {
    const dispatch = useDispatch();
    const [phone, setPhone] = useState();
    const [start, setStart] = useState(false);
    const [progress, setProgress] = useState(0);
    const amplitudeEventData = useSelector(selectEventsData);

    const onStartClick = () => {
        setStart(true);
        sendAnalyticsEvents(EVENTS.enterPhoneButtonClick, amplitudeEventData);
    };

    useEffect(() => sendAnalyticsEvents(EVENTS.enterPhoneToTrack, amplitudeEventData), []);

    useEffect(() => {
        if (progress === 100) {
            dispatch(setTrackingStatus(true));
            dispatch(setPseudoPhone(phone))
        }
    }, [progress])

    useEffect(() => {
        if (phone && start) {
            const timer = setInterval(() => {
                setProgress((prevProgress) => (prevProgress >= 100 ? 100 : prevProgress + 1));
            }, 50);
            return () => {
                clearInterval(timer);
            };
        }

    }, [phone, start]);

    if (phone && start) {
        return (
            <StyledWrapper>
                <StyledTitle>{`Looking for ${phone}`}</StyledTitle>
                <StyledText>Identifying the network operator.</StyledText>
                <StyledText>Searching for the cellular base station...</StyledText>
                <StyledProgressWrap>
                    <ProgressBar progress={progress}/>
                </StyledProgressWrap>
            </StyledWrapper>
        )
    }


    return (
        <StyledWrapper>
            <StyledTitle>Now let’s locate your loved one!</StyledTitle>
            <StyledContainer>
                <PhoneInputComp phone={phone} setPhone={setPhone} country={country}/>
                <StyledButton onClick={onStartClick} id='continue-button'>Start Tracking</StyledButton>
            </StyledContainer>
        </StyledWrapper>

    )
};

export default LocatingPopup;